import { faPeopleArrows, faRectangleHistoryCircleUser, faUserPlus } from '@fortawesome/pro-regular-svg-icons';
import { match } from 'ts-pattern';

import { ValueOf } from 'lib/core/types';

import CONTACT_TYPES from 'lib/common/constants/contactTypes';

export const getTaskTypeTransferAttributes = (taskType?: ValueOf<typeof CONTACT_TYPES> | null) => {
  return match(taskType)
    .with(CONTACT_TYPES.OUTBOUND_PREVIEW, CONTACT_TYPES.EMAIL, CONTACT_TYPES.TASK, CONTACT_TYPES.CHAT, () => ({
      directoryTransferTitle: 'Directory Transfer',
      directoryTransferTooltip: 'Directory Transfer',
      directoryTransferButtonIcon: faPeopleArrows,
      queueTransferTitle: 'Queue Transfer',
      queueTransferTooltip: 'Queue Transfer',
      queueTransferButtonIcon: faRectangleHistoryCircleUser,
      transferButtonLabel: 'Transfer',
    }))
    .otherwise(() => ({
      directoryTransferTitle: 'Add Directory Participant',
      directoryTransferTooltip: 'Add Directory Participant',
      directoryTransferButtonIcon: faUserPlus,
      queueTransferTitle: 'Add Queue Participant',
      queueTransferTooltip: 'Add Queue Participant',
      queueTransferButtonIcon: faRectangleHistoryCircleUser,
      transferButtonLabel: 'Add',
    }));
};
